export function normalizeWorkflowStatusName(name) {
  return String(name || "")
    .trim()
    .toLowerCase();
}

export function shouldUpdateExistingRecordToInProgress(lastStatusName) {
  if (lastStatusName == null || String(lastStatusName).trim() === "") {
    return true;
  }
  const canonical = String(lastStatusName)
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
  return canonical !== "in_progress";
}

export function parseUserIdFromStatusLike(statusLike) {
  if (!statusLike || typeof statusLike !== "object") return null;
  const rawCandidates = [
    statusLike.id_user,
    statusLike.user_id,
    statusLike.reviewer_id,
    statusLike.id_reviewer,
    statusLike.user && statusLike.user.id,
  ];
  for (const raw of rawCandidates) {
    if (raw == null || raw === "") continue;
    const parsed = Number(raw);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

export function getScheduledStatusUserIdFromItem(item) {
  if (!item) return null;
  const fromLastStatus = parseUserIdFromStatusLike(item.last_status);
  if (fromLastStatus != null) return fromLastStatus;
  return parseUserIdFromStatusLike(item.status);
}

export function getCurrentUserIdFromLocalStorage() {
  try {
    const raw = localStorage.getItem("userData");
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed.id != null ? Number(parsed.id) : null;
  } catch {
    return null;
  }
}
function getTemplateShapedAnswer(item) {
  if (!item) return undefined;
  if ("formAnswer" in item) return item.formAnswer;
  if ("answer" in item) return item.answer;
  return undefined;
}

export function isRiskFormAnswerEmpty(item) {
  const answer = getTemplateShapedAnswer(item);
  if (answer === undefined) return false;
  return !answer;
}

export function isScheduledOrReassignedStatus(name) {
  const canonical = normalizeWorkflowStatusName(name);
  return canonical === "scheduled" || canonical === "reassigned";
}

export function resolveScheduledAssigneeDisplay(item, findUserById) {
  if (!item || !item.last_status) return null;
  if (!isScheduledOrReassignedStatus(item.last_status.name)) return null;

  const userId = getScheduledStatusUserIdFromItem(item);
  if (userId == null || typeof findUserById !== "function") return null;

  const user = findUserById(userId);
  if (!user) return null;

  return {
    name: user.full_name || user.name || user.username || user.user || null,
    email: user.email || null,
    username: user.username || user.user || null,
  };
}

export function buildRowFromFormSelectionPayload(payload) {
  return {
    id: payload.id,
    reference_number: payload.referenceNumber || "",
    id_unit: payload.unitId,
    unit: payload.unit,
    ...(payload.lastStatusName ? { last_status: { name: payload.lastStatusName } } : {}),
  };
}

export function canShowScheduledStartForm(item) {
  if (!item || !item.last_status) return false;
  const statusName = normalizeWorkflowStatusName(item.last_status.name);
  const isScheduled = statusName === "scheduled";
  const isEmptyReassigned = statusName === "reassigned" && isRiskFormAnswerEmpty(item);
  if (!isScheduled && !isEmptyReassigned) {
    return false;
  }
  const scheduledUserId = getScheduledStatusUserIdFromItem(item);
  const currentUserId = getCurrentUserIdFromLocalStorage();
  if (
    scheduledUserId == null ||
    !Number.isFinite(scheduledUserId) ||
    currentUserId == null ||
    !Number.isFinite(currentUserId)
  ) {
    return false;
  }
  return scheduledUserId === currentUserId;
}
